import strings from '@/strings'
import bookingService from '@/api/booking'
import {BOOKING} from '@/store/types'
import utils from '@/utils/utils.js'
import Vue from 'vue'
import Axios from 'axios'
import moment from "moment-timezone";
import errorhandler from '@/utils/errorhandler'
const CancelToken = Axios.CancelToken

let cancelEvents = null
let cancelEventsAttendees = () => { }

const proto = Vue.prototype

function calcEndTime (date) {
  let now = proto.$moment()
  let beforeOf = proto.$moment.tz(date.format(proto.$moment.HTML5_FMT.DATE) + strings.times[36], DATETIME_FORMAT, proto.$moment.tz.guess()).utc()
  let isBefore = proto.$moment(now, 'hh:mmA').isBefore(proto.$moment(beforeOf, 'hh:mmA'))
  return isBefore ? strings.times[36] : strings.times[47]
}

function getCostCenter(costCenterItem, hasCostCenter, initialCosteCenter) {
  let costCenterValue;
  if (hasCostCenter) {
    costCenterValue = costCenterItem === '' ? initialCosteCenter : costCenterItem
  } else {
    costCenterValue = costCenterItem
  }
  return costCenterValue
}

const DATETIME_FORMAT = 'YYYY-MM-DDhh:mma'

export default {
  namespaced: true,
  state: {
    locationSelected: [],
    peopleSelected: 1,
    equipmentSelected: [],
    date: null, // fix: precisa ser iniciado para nao estourar erro no <calendar
    startTime: null,
    endTime: null,
    duration: 30,
    startDateSelected: null,
    endDateSelected: null,
    endDateSearched: null,
    roomSelected: null,
    roomsSelected: [],
    result: [],
    dateResult: null,
    bookings: null,
    slotsLoadingStatus: 'STATUS_INITIAL',
    offset: 0,
    total: 0,
    actualView: 0,
    attendeesEvents: [],
    attendees: [],
    slotSelected: null,
    usersOwner: [],
    event: {},
    selectedServices:  [],
    eventError: false,
    eventErrorData: [],
    costCenters: []
  },
  getters: {
    hasDuration (state) {
      return state.duration
    },
    hasLocation (state) {
      return state.locationSelected && state.locationSelected.length > 0
    },
    locationSelected (state) {
      return state.locationSelected
    },
    date (state) {
      return state.date
    },
    startTime (state) {
      return state.startTime ? state.startTime : utils.getNearestInterval(30).subtract(30, 'minutes').format('hh:mmA')
    },
    endTime (state) {
      return state.endTime ? state.endTime : calcEndTime(state.date)
    },
    equipmentSelected (state) {
      return state.equipmentSelected
    },
    peopleSelected (state) {
      return state.peopleSelected
    },
    duration (state) {
      return state.duration
    },
    startDate (state, getters) {
      if (state.date && getters.startTime) {
        return proto.$moment.tz(state.date.format(proto.$moment.HTML5_FMT.DATE) + getters.startTime, DATETIME_FORMAT, proto.$moment.tz.guess()).utc()
      }
    },
    endDate (state, getters) {
      if (state.date && getters.endTime) {
        if (getters.endTime === '12AM') {
          return proto.$moment.tz(state.date.clone().add('days', 1).format(proto.$moment.HTML5_FMT.DATE) + getters.endTime, DATETIME_FORMAT, proto.$moment.tz.guess()).utc()
        }
        return proto.$moment.tz(state.date.format(proto.$moment.HTML5_FMT.DATE) + getters.endTime, DATETIME_FORMAT, proto.$moment.tz.guess()).utc()
      }
    },
    invalidDuration (state, getters) {
      let endTime = (strings.times.indexOf(getters.endTime))
      if (getters.endTime === '12AM') {
        endTime = 24
      }
      return ((endTime - strings.times.indexOf(getters.startTime)) * 60) < parseInt(state.duration)
    },
    invalidRange (state, getters) {
      let endTime = (strings.times.indexOf(getters.endTime))
      if (state.endTime === '12AM') {
        endTime = 24
      }
      return (strings.times.indexOf(getters.startTime) - endTime >= 0)
    },
    hasResult (state) {
      return state.result.length > 0 && state.endDateSearched && state.endDateSearched.isAfter(proto.$moment())
    },
    startDateSelected (state) {
      return state.startDateSelected
    },
    endDateSelected (state) {
      return state.endDateSelected
    },
    roomSelected (state) {
      return state.roomSelected
    },
    roomsSelected (state) {
      return state.roomsSelected
    },
    isPresentDay (state) {
      if (state.date) {
        return utils.isPresentDay(state.date)
      } else {
        return false
      }
    },
    slotSelected (state) {
      return state.slotSelected
    },
    event (state) {
      return state.event
    },
    selectedServices (state) {
      return state.selectedServices
    },
    eventError (state) {
      return state.eventError
    }
  },
  mutations: {
    [BOOKING.SET_LOCATION_SELECTED] (state, value) {
      state.locationSelected = value
    },
    [BOOKING.SET_EQUIPMENT_SELECTED] (state, value) {
      state.equipmentSelected = value
    },
    [BOOKING.SET_PEOPLE_SELECTED] (state, value) {
      state.peopleSelected = value
    },
    [BOOKING.SET_DURATION] (state, value) {
      state.duration = value
    },
    [BOOKING.SET_START_TIME] (state, value) {
      state.startTime = value
    },
    [BOOKING.SET_DATE] (state, value) {
      state.date = value
    },
    [BOOKING.SET_END_TIME] (state, value) {
      state.endTime = value
    },
    [BOOKING.SET_RESULT] (state, result) {
      state.result = state.result.concat(result)
    },
    [BOOKING.SET_ROOM_SELECTED] (state, value) {
      state.roomSelected = value
    },
    [BOOKING.SET_SELECTED_ROOMS] (state, rooms) {
      state.roomsSelected = rooms
    },
    [BOOKING.PUSH_ROOM] (state, room) {
      state.roomsSelected.push(room)
    },
    [BOOKING.REMOVE_ROOM] (state, index) {
      state.roomsSelected.splice(index, 1)
    },
    [BOOKING.SET_START_SELECTED] (state, value) {
      state.startDateSelected = value
    },
    [BOOKING.SET_END_SELECTED] (state, value) {
      state.endDateSelected = value
    },
    [BOOKING.SET_BOOKINGS] (state, result) {
      state.bookings = []
      state.bookings = result
    },
    [BOOKING.END_DATE_SEARCHED] (state, value) {
      state.endDateSearched = value
    },
    [BOOKING.PUSH_LOCATION_SELECTED] (state, id) {
      if (state.locationSelected.indexOf(id) === -1) {
        state.locationSelected.push(id)
      }
    },
    [BOOKING.SET_LOADING_STATUS] (state, slotsLoadingStatus) {
      state.slotsLoadingStatus = slotsLoadingStatus
    },
    [BOOKING.INCREASE_OFFSET] (state) {
      state.offset++
    },
    [BOOKING.CLEAR_ALL] (state) {
      cancelEvents()
      state.slotsLoadingStatus = 'STATUS_INITIAL'
      state.result = []
      state.offset = 0
      state.total = 0
      state.actualView = 0
    },
    [BOOKING.CLEAR_ATTENDEES] (state) {
      cancelEventsAttendees()
      state.attendees = []
      state.attendeesEvents = []
    },
    [BOOKING.SET_TOTAL_RESULT] (state, total) {
      state.total = total
    },
    [BOOKING.SET_DATE_RESULT] (state) {
      state.dateResult = null
      state.dateResult = state.date
    },
    [BOOKING.INCREASE_ACTUALVIEW] (state) {
      state.actualView++
    },
    [BOOKING.DECREASE_ACTUALVIEW] (state) {
      state.actualView--
    },
    [BOOKING.PUSH_EVENTS_ATTENDEES] (state, attendeesEvents) {
      state.attendeesEvents.push(attendeesEvents)
    },
    [BOOKING.REMOVE_EVENTS_ATTENDEE] (state, index) {
      state.attendeesEvents.splice(index, 1)
    },
    [BOOKING.PUSH_ATTENDEES] (state, email) {
      state.attendees.push(email)
    },
    [BOOKING.REMOVE_ATTENDEE] (state, index) {
      state.attendees.splice(index, 1)
    },
    [BOOKING.SET_ATTENDEES] (state, attendees) {
      state.attendees = attendees
    },
    [BOOKING.ADD_EVENTS_ATTENDEES] (state, attendee) {
      for (let i = state.attendeesEvents.length - 1; i >= 0; i--) {
        if (state.attendeesEvents[i].email === attendee.email) {
          Vue.set(state.attendeesEvents[i], 'events', attendee.events)
          break
        }
      }
    },
    [BOOKING.SET_ATTENDEE_EVENTS_ERROR] (state, attendee) {
      for (let i = state.attendeesEvents.length - 1; i >= 0; i--) {
        if (state.attendeesEvents[i].email === attendee.email) {
          Vue.set(state.attendeesEvents[i], 'errorMessage', attendee.errorMessage)
          break
        }
      }
    },
    [BOOKING.SET_SLOT_SELECTED] (state, value) {
      state.slotSelected = value
    },
    [BOOKING.SET_USER_OWNER] (state, users) {
      state.usersOwner = users
    },
    [BOOKING.PUSH_USER_OWNER] (state, email) {
      state.usersOwner = []
      state.usersOwner.push(email)
    },
    [BOOKING.REMOVE_USER_OWNER] (state, index) {
      state.usersOwner.splice(index, 1)
    },
    [BOOKING.CLEAR_USER_OWNER] (state) {
      state.usersOwner = []
    },
    [BOOKING.SET_EVENT] (state, event) {
      state.event = event
    },
    [BOOKING.SET_SELECTED_SERVICES] (state, selectedServices) {
      state.selectedServices = selectedServices
    },
    [BOOKING.SET_EVENT_ERROR] (state, value) {
      state.eventError = value
    },
    [BOOKING.SET_EVENT_ERROR_DATA] (state, data) {
      state.eventErrorData = data
    },
    [BOOKING.SET_COST_CENTERS] (state, costCenters) {
      state.costCenters = costCenters
    },
    [BOOKING.PUSH_COST_CENTER] (state, code) {
      state.costCenters.push(code)
    },
    [BOOKING.REMOVE_COST_CENTER] (state, index) {
      state.costCenters.splice(index, 1)
    },
    [BOOKING.CLEAR_COST_CENTER] (state) {
      state.costCenters = []
    }
  },
  actions: {
    setLocationSelected ({commit}, value) {
      commit(BOOKING.SET_LOCATION_SELECTED, value)
    },
    pushLocationSelected ({commit}, value) {
      commit(BOOKING.PUSH_LOCATION_SELECTED, value)
    },
    setDate ({commit}, value) {
      commit(BOOKING.SET_DATE, value)
    },
    setEquipmentSelected ({commit}, value) {
      commit(BOOKING.SET_EQUIPMENT_SELECTED, value)
    },
    setPeopleSelected ({commit}, value) {
      commit(BOOKING.SET_PEOPLE_SELECTED, value)
    },
    setDuration ({commit}, value) {
      commit(BOOKING.SET_DURATION, value)
    },
    setStartTime ({commit}, value) {
      commit(BOOKING.SET_START_TIME, value)
    },
    setEndTime ({commit}, value) {
      commit(BOOKING.SET_END_TIME, value)
    },
    checkAddOneDay ({ commit, dispatch, getters }) {

      if (getters.startDate.isBefore(proto.$moment())) {
        if (getters.endDate.isBefore(proto.$moment())) {
          commit('SET_DATE', proto.$moment().add('day', 1))
          dispatch('Global/showMessage', 'oneDayAdded', {root: true})
        } else {
          commit('SET_START_TIME', utils.getNearestInterval(30).subtract(30, 'minutes').format('hh:mmA'))
        }
      }
    },
    getEvents ({ commit, state, getters }) {
      return new Promise(resolve => {
        commit(BOOKING.END_DATE_SEARCHED, proto.$moment.utc(getters.endDate.format()))

        commit(BOOKING.SET_DATE_RESULT)
        let cancelToken = new CancelToken(function executor (c) {
          cancelEvents = c
        })

        bookingService.getEvents(cancelToken, state.offset * strings.roomsLimit, strings.roomsLimit, state.locationSelected, getters.startDate.format(), getters.endDate.format(), state.peopleSelected, state.equipmentSelected).then((response) => {
          commit(BOOKING.SET_RESULT, response.data.rooms)
          commit(BOOKING.INCREASE_OFFSET)
          commit(BOOKING.SET_TOTAL_RESULT, response.data.totalRooms)
          if (state.result.length >= state.total) {
            commit(BOOKING.SET_LOADING_STATUS, 'STATUS_END')
          } else {
            commit(BOOKING.SET_LOADING_STATUS, 'STATUS_SUCCESS')
          }
          resolve()
        }).catch((thrown) => {
          if (Axios.isCancel(thrown)) {
            commit(BOOKING.SET_LOADING_STATUS, 'STATUS_FAILED')
            Vue.nextTick(() => {
              commit(BOOKING.SET_LOADING_STATUS, 'STATUS_INITIAL')
            })
          } else {
            commit(BOOKING.SET_LOADING_STATUS, 'STATUS_FAILED')
          }
        })
      })
    },
    findFreeBusyByLocation ({rootGetters}, filter) {
      return new Promise(resolve => {
        const duration = proto.$moment.duration(filter.endTime.diff(filter.startTime)).asMinutes()

        // busca na freeBusy algum evento em outras salas, as que não retornarem dados serão listadas
        bookingService.findFreeBusy(filter.location.id, filter.startTime.clone().utc().format(), filter.endTime.clone().utc().format(), duration, [], []).then(response => {
          let locationWithBusy = response.data
          let rooms = []
          if (locationWithBusy.roomsFreeBusy && locationWithBusy.roomsFreeBusy.length > 0) {
            for (var room of locationWithBusy.roomsFreeBusy) {
              // se sala não tiver eventos no periodo selecionado, retorna pra tela
              if (filter.roomsToIgnoreValidation.some(r => r.id === room.id) || !room.busyTimes || room.busyTimes.length === 0) {
                let roomStored = rootGetters['Global/roomMap'][room.roomId]
                rooms.push(roomStored)
              }
            }
          }
          resolve(rooms)
        }).catch(() => {
          resolve(null)
        })
      })
    },
    async findFreeBusyRooms({ dispatch }, filter) {
      const {eventId, startDate, endDate, roomIds } = filter;
          
      try {
        let response = await bookingService.findFreeBusyRooms(eventId, startDate.format(), endDate.format(), roomIds);
        return response.data;
      } catch (error) {
        errorhandler.handleError(error);
      } finally {
        dispatch('Global/hideLoading', null, { root: true });
      }
    },
    // eslint-disable-next-line no-empty-pattern
    saveStore ({}, event) {
      return bookingService.save({
        id: event.id,
        startDate: event.startTime,
        endDate: event.endTime,
        rooms: event.rooms.map((room) => room.id),
        email: event.email,
        title: event.title,
        isPrivateEvent: event.isPrivateEvent,
        attendees: event.attendees,
        description: event.description,
        numberOfOcurrences: event.numberOfOcurrences,
        recurrence: event.recurrence,
        timeZone: event.timeZone,
        costCenters: event.costCenters,
        serviceDeskRequest: event.serviceDeskRequest,
        eventTypeId: event.eventTypeId
      })
    },
    cancelEvent ({rootGetters}, id) {
      const userEmail = rootGetters['Auth/userEmail']

      return bookingService.cancel(userEmail, id)
    },
    getBookingEvent({dispatch, commit, rootState}, id) {
      return new Promise((resolve) => {
        dispatch('Global/showLoading', null, {root: true})
        bookingService.getBookingEvent(id).then((response) => {
          let item = response.data
          let eventToModal = {
            isEdit: true,
            id: item.eventId,
            startTime: moment(item.startDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').tz(moment.tz.guess()),
            endTime: moment(item.endDate, 'YYYY-MM-DDTHH:mm:ss.SSSZ').tz(moment.tz.guess()),
            rooms: item.rooms,
            isRecurrent: item.isRecurrent,
            recurrenceMasterId: item.recurrenceMasterId,
            recurrence: item.recurrence,
            numberOfOcurrences: item.numberOfOcurrences,
            title: item.title,
            isPrivateEvent: item.isPrivateEvent,
            attendees: JSON.parse(JSON.stringify(item.attendees)),
            description: item.description,
            owner: item.email,
            costCenters: getCostCenter(item.costCenters, rootState.Global.initialSettings.hasCostCenter, rootState.Global.initialSettings.user.costCenter),
            serviceDeskRequest: item.serviceDeskRequest,
            isOnlineMeeting: item.isOnlineMeeting,
            onlineMeetingUrl: item.onlineMeetingUrl,
            eventTypeId: item.eventTypeId
          }
          commit(BOOKING.SET_EVENT, eventToModal)
          resolve()
        }).finally(() => {
          dispatch('Global/hideLoading', null, {root: true})
        })
      })
    },
    findBooks ({dispatch, commit, rootGetters}, filter) {
      return new Promise((resolve, reject) => {
        dispatch('Global/showLoading', null, {root: true})
        let userEmail = rootGetters['Auth/userEmail']
        bookingService.findBooks(userEmail, filter.startDate, filter.endDate).then((response) => {
          for (var book of response.data) {
            let rooms = []
            for (var room of book.rooms) {
              let roomDetails = Object.assign({}, rootGetters['Global/roomMap'][room.roomId])
              roomDetails.rejected = room.rejected
              roomDetails.isApproved = room.isApproved
              roomDetails.eventsNeedApproval = room.eventsNeedApproval
              rooms.push(roomDetails)
            }
            book.rooms = rooms
          }
          commit(BOOKING.SET_BOOKINGS, response.data)
          dispatch('Global/hideLoading', null, {root: true})
          resolve()
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    roomSelected ({ commit }, value) {
      commit(BOOKING.SET_ROOM_SELECTED, value)
    },
    setSelectedRooms ({ commit }, rooms) {
      commit(BOOKING.SET_SELECTED_ROOMS, rooms)
    },
    pushSelectedRoom ({ commit, state, rootGetters }, item) {
      if (state.roomsSelected.filter(room => room.id === item.id).length === 0) {

        let roomStored = rootGetters['Global/roomMap'][item.id]

        commit(BOOKING.PUSH_ROOM, roomStored)
      }
    },
    removeSelectedRoom ({ commit }, index) {
      commit(BOOKING.REMOVE_ROOM, index)
    },
    startDateSelected ({ commit }, value) {
      commit(BOOKING.SET_START_SELECTED, value)
    },
    endDateSelected ({ commit }, value) {
      commit(BOOKING.SET_END_SELECTED, value)
    },
    date ({ commit }, value) {
      commit(BOOKING.SET_DATE, value)
    },
    setWaitingSlotsLoadingStatus: function ({ commit }) {
      commit(BOOKING.SET_LOADING_STATUS, 'STATUS_WAITING')
    },
    clearAll: function ({ commit }) {
      commit(BOOKING.CLEAR_ALL)
    },
    nextRoom: function ({ state, commit, dispatch }) {
      if (state.actualView !== state.total - 1) {
        commit(BOOKING.INCREASE_ACTUALVIEW)
        if (state.actualView === ((state.offset * strings.roomsLimit) - 2) && state.slotsLoadingStatus !== 'STATUS_END') {
          dispatch('getEvents')
        }
      }
    },
    previousRoom: function ({ state, commit }) {
      if (state.actualView > 0) {
        commit(BOOKING.DECREASE_ACTUALVIEW)
      }
    },
    getEventsAttendees ({ commit, state, getters, dispatch, rootGetters }, attendee) {
      dispatch('checkAddOneDay')
      if (!rootGetters['Auth/hasAgenda']) {
        return
      }
      if (state.attendeesEvents.filter(attendeeState => attendeeState.email === attendee).length === 0) {
        commit(BOOKING.PUSH_EVENTS_ATTENDEES, attendee)
        return new Promise((resolve, reject) => {
          let cancelToken = new CancelToken(function executor (c) {
            cancelEventsAttendees = c
          })
          bookingService.getEventsAttendees(cancelToken, getters.startDate.format(), getters.endDate.format(), attendee.email).then((response) => {
            Vue.set(attendee, 'events', response.data.events)
            commit(BOOKING.ADD_EVENTS_ATTENDEES, attendee)
            resolve()
          }).catch((error) => {
            if (error.response.status === 404) {
              Vue.set(attendee, 'errorMessage', 'attendeeNotFound')
              commit(BOOKING.SET_ATTENDEE_EVENTS_ERROR, attendee)
            } else {
              commit(BOOKING.REMOVE_EVENTS_ATTENDEE, state.attendeesEvents.indexOf(attendee))
            }

            reject(error)
          })
        })
      } else {
        dispatch('Global/showMessage', 'attendeeDuplicated', {root: true})
      }
    },
    getAllEventsAttendees ({rootState, commit}, getEventsAttendees) {
      var allAttendees = rootState.Booking.attendeesEvents.map(function (item) {
        return item
      })

      commit(BOOKING.CLEAR_ATTENDEES)

      allAttendees.forEach(element => {
        getEventsAttendees(element)
      })
    },
    removeAttendeeEvents ({ commit }, index) {
      commit(BOOKING.REMOVE_EVENTS_ATTENDEE, index)
    },
    pushAttendee ({ state, commit, dispatch }, item) {
      if (state.attendees.filter(user => user.email === item.email).length === 0) {
        commit(BOOKING.PUSH_ATTENDEES, item)
      } else {
        dispatch('Global/showMessage', 'attendeeDuplicated', {root: true})
      }
    },
    removeAttendee ({ commit }, index) {
      commit(BOOKING.REMOVE_ATTENDEE, index)
    },
    setAttendees ({ commit }, attendees) {
      commit(BOOKING.SET_ATTENDEES, attendees)
    },
    clearAttendees ({ commit }) {
      commit(BOOKING.CLEAR_ATTENDEES)
    },
    clearBookings ({ commit }) {
      commit(BOOKING.SET_BOOKINGS, [])
    },
    setDefaultSearchTime ({ state, dispatch }) {
      let isSameDay = proto.$moment(state.date, 'day').isSame(proto.$moment(), 'day')
      let startTime = isSameDay ? utils.getNearestInterval(30).subtract(30, 'minutes').format('hh:mmA') : strings.times[16]
      let endTime = isSameDay ? calcEndTime(state.date) : strings.times[36]
      dispatch('setStartTime', startTime)
      dispatch('setEndTime', endTime)
    },
    slotSelected ({ commit }, value) {
      commit(BOOKING.SET_SLOT_SELECTED, value)
    },
    // eslint-disable-next-line no-empty-pattern
    cancelRoomEvent ({}, cancelParameters) {
      return bookingService.cancelRoomEvent(cancelParameters)
    },
    pushUserOwner ({ state, commit, dispatch }, item) {
      if (state.usersOwner.filter(user => user.email === item.email).length === 0) {
        commit(BOOKING.PUSH_USER_OWNER, item)
      } else {
        dispatch('Global/showMessage', 'userDuplicated', {root: true})
      }
    },
    removeUserOwner ({ commit }, index) {
      commit(BOOKING.REMOVE_USER_OWNER, index)
    },
    clearUsersOwner ({ commit }) {
      commit(BOOKING.CLEAR_USER_OWNER)
    },
    setUsersOwner ({ commit }, usersOwner) {
      commit(BOOKING.SET_USER_OWNER, usersOwner)
    },
    setEvent ({commit}, event) {
      commit(BOOKING.SET_EVENT, event)
    },
    setSelectedServices ({commit}, selectedServices) {
      commit(BOOKING.SET_SELECTED_SERVICES, selectedServices)
    },
    setEventError({commit}, value) {
      commit(BOOKING.SET_EVENT_ERROR, value)
    },
    setEventErrorData({commit}, data) {
      commit(BOOKING.SET_EVENT_ERROR_DATA, data)
    },
    pushCostCenter ({ state, commit, dispatch }, item) {
      if (state.costCenters.filter(costCenter => costCenter.code === item.code).length === 0) {
        commit(BOOKING.PUSH_COST_CENTER, item)
      } else {
        dispatch('Global/showMessage', 'costCenterDuplicated', {root: true})
      }
    },
    clearCostCenter ({ commit }) {
      commit(BOOKING.CLEAR_COST_CENTER)
    },
    removeCostCenter ({ commit }, index) {
      commit(BOOKING.REMOVE_COST_CENTER, index)
    },
    setCostCenter ({ commit }, costCenters) {
      commit(BOOKING.SET_COST_CENTERS, costCenters)
    },
    resetInitialLocation({commit, rootState}){
      commit('SET_LOCATION_SELECTED', [rootState.Global.initialSettings.user.meetingSpace.favoriteLocationId])
    }
  }
}
